<script>
import Notification from '../reUse/Notification.vue';
import DropDown from '../reUse/DropDown.vue';
import Zapisi from './ZapisRazpored.vue';
import {i18n} from '@/i18n'
import sl from '@/Prevodi/DnevniRazpored-sl.json';
import en from '@/Prevodi/DnevniRazpored-en.json';
import it from '@/Prevodi/DnevniRazpored-it.json';
import {config} from "@/config";

export default {
  components: {
    Notification,
    DropDown,
    Zapisi
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      KreacijaDok: false,
      prikaz: 'vnos',
      text: '',
      types: '',
      ShowNoti: false,
      dLetalo: false,
      dNamen: false,
      dNaloga: false,
      vnos: false,
      vnosAktivnost: false,
      // Podatki ki jih pošljemo
      // letala: [
      // {id:0, vrsta_letala: 'Motorno'},
      // {id:1, vrsta_letala: 'Jadralno'},
      // {id:2, vrsta_letala: 'UltraLight'},
      // ],
      v_letala: '',
      // opomba: '',
      casAktivnosti: '',
      Aktivnost: '',
      Planirano: '',
      Sredstvo: '',
      Izvrsilec: '',
      IzbranaNaloga: '',
      sredstva: [{
        'reg': ''
      }],
      Letala: [],
      regLetala: '',
      namen: [
        {id: 0, namen: 'Trenažni let'},
        {id: 1, namen: 'Kontrolni let'},
        {id: 2, namen: 'Osnovno šolanje'},
        {id: 3, namen: 'Šolanje za poob.'},
        {id: 4, namen: 'Tekmovalni let'},
        {id: 5, namen: 'Izpitni let'},
        {id: 6, namen: 'Preizkusni let'},
        {id: 7, namen: 'Uvodni let'},
        {id: 8, namen: 'Protipožarni let'},
        {id: 9, namen: 'AK'},
        {id: 10, namen: 'DRUGO'},
        {id: 11, namen: 'Vleka'}
      ],
      naloga: [
        {id: 0, naloga: 'Šolski krog'},
        {id: 1, naloga: 'Let v rajonu'},
        {id: 2, naloga: 'Prelet'},
        {id: 3, naloga: 'Ruta'},
      ],
      user: config.FullUser,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.Izvrsilec = this.user.imepriimek;
    this.GetLetala();
  },
  computed: {},
  methods: {
    OpenKreacija() {
      this.KreacijaDok = !this.KreacijaDok;
    },
    GetLetala() {
      let app = this;
      axios.get("./api/sifranti/letala/izpis/").then((response) => {
        this.Letala = response.data.letala;
      })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    VnesiAktivnost() {
      this.vnosAktivnost = true;
      let dodaj = new URLSearchParams();
      dodaj.append('aktivnost', this.Aktivnost);
      dodaj.append('cas', this.casAktivnosti);
      axios
          .post("./api/dnevniplan/aktivnosti/vnos/", dodaj, {withCredentials: true})
          .then((response) => {
            // this.text = response.data.sporocilo;
            this.text = this.$t('obvestila.vnosUspesen');
            this.types = 'Uspešno';
            this.ShowNoti = true;
            this.Aktivnost = '';
            this.casAktivnosti = '';
            this.vnosAktivnost = false;
          })
          .catch((napaka) => {
            this.vnosAktivnost = false;
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              // this.text = 'Napaka pri vnosu podatkov. '+napaka.response.data.napaka;
              this.text = this.$t('obvestila.vnosNeuspesen');
            } else {
              // this.text = 'Napaka pri vnosu podatkov.';
              this.text = this.$t('obvestila.vnosNeuspesen');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
            this.ErrorReport('napaka-dnevni-razpored-vnos', '/api/dnevniplan/aktivnosti/vnos/', 'VnesiAktivnost()', 'dnevni-razpored-vnos-aktivnost', this.text);
          })
    },
    VnesiRazpored() {
      this.vnos = true;
      if (this.Planirano === '' || this.Izvrsilec === '' || this.v_letala === '' || this.IzbranaNaloga === '') {
        this.text = this.$t('obvestila.napakaInputa');
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.vnos = false;
        return;
      }

      // const veljavnaSredstva = this.sredstva
      //     .map(s => (s.reg || '').trim())
      //     .filter(s => s !== '');

      // if (veljavnaSredstva.length === 0) {
      //     this.text = 'Vnesite vsaj eno sredstvo (letalo), npr. S5-XYZ.';
      //     this.types = 'Napaka';
      //     this.ShowNoti = true;
      //     return;
      // }

      let dodaj = new URLSearchParams();
      // this.Sredstvo = veljavnaSredstva.join(';');
      dodaj.append('planirano', this.Planirano);
      // dodaj.append('sredstvo', this.Sredstvo);
      dodaj.append('sredstvo', this.regLetala);
      if (this.Izvrsilec === this.user.imepriimek) {
        dodaj.append('izvrsilec', this.user.id);
      } else {
        dodaj.append('izvrsilec', this.Izvrsilec);
      }
      dodaj.append('vrsta_letala', this.v_letala);
      dodaj.append('naloga', this.IzbranaNaloga);
      axios
          .post("./api/dnevniplan/razpored/vnos/", dodaj, {withCredentials: true})
          .then((response) => {
            // this.text = response.data.sporocilo; // sporocilo iz apija
            this.text = this.$t('obvestila.vnosUspesen');
            this.types = 'Uspešno';
            this.ShowNoti = true;
            this.Planirano = '';
            this.IzbranaNaloga = '';
            // this.Sredstvo = '';
            this.regLetala = '';
            // this.Izvrsilec = '';
            this.sredstva = [];
            this.sredstva.push({'reg': ''});
            this.v_letala = '';
            this.vnos = false;
          })
          .catch((napaka) => {
            this.vnos = false;
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              // this.text = 'Napaka pri vnosu podatkov. '+napaka.response.data.napaka;
              this.text = this.$t('obvestila.vnosNeuspesen') + '\n' + napaka.response.data.napaka;
            } else {
              // this.text = 'Napaka pri vnosu podatkov.';
              this.text = this.$t('obvestila.vnosNeuspesen');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
            this.ErrorReport('napaka-dnevni-razpored-vnos', '/api/dnevniplan/razpored/vnos/', 'VnesiRazpored()', 'dnevni-razpored-vnos', this.text);
          })
    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]); //samo za dev
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    selectLetalo(id) {
      // let letalo = this.Letala.letala.find(l => l.id === id);
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        if (!letalo.plovnost) {
          this.text = `Izbrali ste letalo katerega je upravitelj označil kot \'neplovno\'. Opomba: ${letalo.plovnost_opomba !== null ? letalo.plovnost_opomba : '/'}`;
          this.types = 'Napaka';
          this.ShowNoti = true;
        }
        this.v_letala = letalo.vrsta_letala;
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    selectNamen(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamen = false;
        this.Planirano = namen.namen;
      }
    },
    selectNaloga(id) {
      let naloga = this.naloga.find(na => na.id === id);
      if (naloga) {
        this.dNaloga = false;
        this.IzbranaNaloga = naloga.naloga;
      }
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenNamen() {
      this.dNamen = !this.dNamen;
    },
    OpenNaloga() {
      this.dNaloga = !this.dNaloga;
    },
    DodajSredstvo() {
      if (this.sredstva.length <= 15) {
        this.sredstva.push({reg: ''});
      }

    },
    OdstraniSredstvo(index) {
      this.text = this.$t('obvestila.brisiSredstvo');
      this.types = 'Vprašanje';
      this.ShowNoti = true;
      this.indexBrisanja = index;
    },
    OdgovoriDa() {
      this.sredstva.splice(this.indexBrisanja, 1);
      this.ShowNoti = false;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    ErrorReport(imeEventa, endpoint = null, metoda = null, imeNapake = null, opisNapake = null) {
      window.umami.track(imeEventa, {
        endpoint: endpoint,
        metoda: metoda,
        akcija: imeNapake,
        opis: opisNapake
      });
    }
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{ $t('main.nazaj') }}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{ $t('main.title') }}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnos'}" @click="prikaz = 'vnos'"
                    data-umami-event="DnevniRapozred-vnos">
              <i class="fas fa-edit"></i>
              <span>{{ $t('nav.vnos') }}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'zapisi'}" @click="prikaz = 'zapisi'"
                    data-umami-event="DnevniRapozred-zapisi">
              <i class="fas fa-list"></i>
              <span>{{ $t('nav.zapisi') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="this.prikaz === 'zapisi' && prevodi">
    <zapisi :user/>
  </div>
  <div class="container p-2" v-show="this.prikaz === 'vnos' && prevodi">
    <!-- AKTIVNOSTI -->
    <h5 class="text-white p-2 text-center"><strong class="text-warning">{{ $t('main.subtitle2') }}</strong>
      {{ $t('main.subSubtitle2') }}</h5>
    <form @submit.prevent="VnesiAktivnost()">
      <div class="col-12">
        <div class="container">
          <label :class="{ hidden: casAktivnosti.length > 0 }" class="label-time p-2"
                 for="casAktivnosti">{{ $t('labels.casAktivnosti') }}</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="casAktivnosti" id="casAktivnosti"
                 v-model="casAktivnosti" required/>
        </div>
      </div>
      <div class="col-12">
        <div class="container">
          <label :class="{ hidden: Aktivnost.length > 0 }" class="label"
                 for="Aktivnost">{{ $t('labels.opisAktivnosti') }}</label>
          <textarea class="input-comment border-0 rounded-4 p-2 fs-5" style="max-height: 400px;" type="textarea"
                    id="Aktivnost" v-model="Aktivnost" rows="4" autocomplete="off">
                        </textarea>
        </div>
      </div>
      <br>
      <div class="container p-2">
        <button type="submit" class="btn btn-primary rounded-pill btn-add col-12"
                data-umami-event="DnevniRapozred-vnos-opozorilo" :disabled="vnosAktivnost">
          {{ $t('buttons.vnesiOpozorilo') }} <i class="fas fa-spinner fa-spin" v-if="vnosAktivnost"></i></button>
      </div>
    </form>
    <br/>
    <!-- RAZPORED LETENJA -->
    <h5 class="text-white p-2 text-center">{{ $t('main.subtitle1') }}</h5>
    <form @submit.prevent="VnesiRazpored()">
      <!--                 <div class="col-12">
                          <div class="container">
                              <label :class="{ hidden: Planirano.length > 0 }" class="label" for="Planirano">{{$t('labels.planirano')}}</label>
                              <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="Planirano" v-model="Planirano" required />
                          </div>
                      </div> -->
      <div class="col-12">
        <!-- NAMEN -->
        <div class="container">
          <label class="label-dropdown" for="namen">{{ $t('labels.planirano') }}
            <button v-if="Planirano !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="Planirano = ''">
              {{ $t('buttons.brisiIzbiro') }}
            </button>
          </label>
          <div class="drop-down-icon text-black" @click.prevent="OpenNamen()">
            <i v-show="!dNamen" class="fas fa-chevron-right"></i>
            <i v-show="dNamen" class="fas fa-chevron-down"></i>
          </div>
          <button id='IzbranNamen' class="input border-0 rounded-4 p-2 fs-5" type="text" @click.prevent="OpenNamen">
            {{ Planirano }}
          </button>
          <transition name="fade">
            <drop-down @namen="selectNamen" :data="namen" type="namen" class="drop-down-btn" v-if="dNamen"/>
          </transition>
        </div>
      </div>
      <!-- NALOGA -->
      <div class="container">
        <label class="label-dropdown" for="namen">{{ $t('labels.naloga') }}
          <button v-if="IzbranaNaloga !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="IzbranaNaloga = ''">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenNaloga()">
          <i v-show="!dNaloga" class="fas fa-chevron-right"></i>
          <i v-show="dNaloga" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="IzbranaNaloga" @click.prevent="OpenNaloga">
          {{ IzbranaNaloga }}
        </button>
        <transition name="fade">
          <drop-down @naloga="selectNaloga" :data="naloga" type="naloga" class="drop-down-btn" v-if="dNaloga"/>
        </transition>
        <div class='text-warning'>
          Pred letom morate obvezno izpolniti kalkulacijo mase in težišča "Weight & Balance"
        </div>
        <div class='text-danger' v-if="this.IzbranaNaloga === 'Ruta' || this.IzbranaNaloga === 'Prelet'">za to vrsto
          leta morate <strong>OBVEZNO</strong> oddati nalog za let!
        </div>
      </div>

      <div class="col-12">
        <!-- REGISTRACIJA -->
        <div class="container">
          <label class="label-dropdown" for="regLetala">{{ $t('labels.sredstvoTitle') }}
            <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning"
                    @click.prevent="regLetala = '', v_letala = ''">{{ $t('buttons.brisiIzbiro') }}
            </button>
          </label>
          <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
            <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
            <i v-show="dLetalo" class="fas fa-chevron-down"></i>
          </div>
          <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">
            {{ regLetala }} {{ (v_letala !== '') ? '[' + v_letala + ']' : '' }}
          </button>
          <transition name="fade">
            <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo"/>
          </transition>
        </div>
      </div>
      <div class="col-12">
        <!-- <div class="container">
            <label :class="{ hidden: Izvrsilec.length > 0 }" class="label" for="Izvrsilec">Izvrsilec</label>
            <textarea class="input-comment border-0 rounded-4 p-2 fs-5" style="max-height: 400px;" type="textarea" id="Izvrsilec" v-model="Izvrsilec" rows="6" autocomplete="off">
            </textarea>
        </div> -->
        <div class="container">
          <label :class="{ hidden: Izvrsilec.length > 0 }" class="label"
                 for="Izvrsilec">{{ $t('labels.izvrsilec') }}</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="Izvrsilec" :disabled="this.user.lvl > 0"
                 v-model="Izvrsilec" required/>
        </div>
      </div>
      <br>
      <!--                 <div class='col-12'>
                          <div class="container">
                              <label class="label-dropdown" for="v_letala">{{$t('labels.vrstaLetala')}}<button v-if="v_letala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="v_letala = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                              <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
                                  <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
                                  <i v-show="dLetalo" class="fas fa-chevron-down"></i>
                              </div>
                              <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="v_letala" @click.prevent="OpenLetalo">{{v_letala}}</button>
                              <transition name="fade">
                                  <drop-down @letalo="selectLetalo" :data="letala" type="v_letala" class="drop-down-btn" v-if="dLetalo" />
                              </transition>
                          </div>
                      </div> -->
      <div class="container p-2">
        <button type="submit" class="btn btn-primary rounded-pill btn-add col-12"
                data-umami-event="DnevniRapozred-vnos-razpored" :disabled="vnos">{{ $t('buttons.vnesiRazpored') }} <i
            class="fas fa-spinner fa-spin" v-if="vnos"></i></button>
      </div>
    </form>
    <br/>
  </div>
  <!-- ODMIK OD CAPTCHE -->
  <div class='col-12 p-5'></div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="OdgovoriDa()" @ne="ShowNoti = false"
                  @closeNotification="ShowNoti = false"/>
  </Transition>
</template>